import { ShipmentsService } from '@/backend/market'
import { ShipmentRepository } from '../../domain/repositories/ShipmentRepository'
import type { ShipmentFilterEntity } from '../../domain/entities/ShipmentFilterEntity'
import { ShipmentFilterModel } from '../models/ShipmentFilterModel'
import { ShipmentMiniModel } from '../models/ShipmentMiniModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import { ShipmentModel } from '../models/ShipmentModel'
import type { ShipmentEntity } from '../../domain/entities/ShipmentEntity'
import { ShipmentStatusModel } from '../models/ShipmentStatusModel'
import type { ShipmentStatusLogEntity } from '../../domain/entities/ShipmentStatusLogEntity'
import { ShipmentRouteModel } from '../models/ShipmentRouteModel'
import type { ShipmentRouteEntity } from '../../domain/entities/ShipmentRouteEntity'
import type { CancelShipmentReasonEntity } from '@/features/cancelShipmentReason/domain/entities/CancelShipmentReasonEntity'
import { ShipmentCustomerModel } from '../models/ShipmentCustomerModel'
import type { ShipmentCustomerEntity } from '../../domain/entities/ShipmentCustomerEntity'
import type { ShipmentMiniEntity } from '../../domain/entities/ShipmentMiniEntity'

export class ShipmentRepositoryImpl implements ShipmentRepository {
  async getShipments(
    filterData: ShipmentFilterEntity
  ): Promise<PaginateEntity<ShipmentMiniEntity[]> | { error: true }> {
    const shipmentFilterModel = new ShipmentFilterModel(filterData)
    try {
      const response = await ShipmentsService.getShipmentsAdmin(shipmentFilterModel as {})
      const shipmentMiniModels = response.items?.map((item) => new ShipmentMiniModel(item))
      const result = new PaginateEntity<ShipmentMiniModel[]>(response, shipmentMiniModels)

      return result
    } catch {
      return { error: true }
    }
  }
  async getShipment(id: string): Promise<ShipmentEntity | { error: true }> {
    try {
      const response = await ShipmentsService.getShipmentAdmin({
        id
      })
      const shipmentModel = new ShipmentModel(response)

      return shipmentModel
    } catch {
      return { error: true }
    }
  }
  async getShipmentStatusLog(id: string): Promise<ShipmentStatusLogEntity[] | { error: true }> {
    try {
      const response = await ShipmentsService.getShipmentStatusesAdmin({
        id
      })
      const shipmentStatusModels = response.statusLogs?.map((log) => new ShipmentStatusModel(log))

      return shipmentStatusModels ?? []
    } catch {
      return { error: true }
    }
  }
  async getShipmentRoutes(shipmentId: string): Promise<ShipmentRouteEntity[] | { error: true }> {
    try {
      const response = await ShipmentsService.getShipmentRoutesAdmin({
        shipmentId
      })
      const shipmentRouteModels = response.items?.map((route) => new ShipmentRouteModel(route))

      return shipmentRouteModels ?? []
    } catch {
      return { error: true }
    }
  }
  async getShipmentCustomerInfo(id: string): Promise<ShipmentCustomerEntity | { error: true }> {
    try {
      const response = await ShipmentsService.getShipmentCustomerInfoAdmin({
        id
      })
      const shipmentCustomerModel = new ShipmentCustomerModel(response)

      return shipmentCustomerModel
    } catch {
      return { error: true }
    }
  }
  async cancelShipment(
    id: string,
    cancelShipmentReason: CancelShipmentReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      await ShipmentsService.postCancelShipmentAdmin({
        id,
        requestBody: {
          cancelShipmentReasonId: cancelShipmentReason.id!
        }
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async transferShipment(
    shipmentId: string,
    driverId: number,
    transferToActiveJob: boolean
  ): Promise<{ success: true } | { error: true }> {
    try {
      await ShipmentsService.transferShipmentAdmin({
        requestBody: {
          shipmentId,
          driverId,
          transferToActiveJob
        }
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
